import { useMemo, useState } from "react";
import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { DoctorCard } from "@/components/DoctorCard";
import { AppointmentCTA } from "@/components/AppointmentCTA";
import { SITE } from "@/config/site";
import { DOCTORS } from "@/data/doctors";

export default function Doctors() {
  const specialties = useMemo(() => ["All", ...new Set(DOCTORS.map((d) => d.specialty))], []);
  const [filter, setFilter] = useState("All");
  const shown = filter === "All" ? DOCTORS : DOCTORS.filter((d) => d.specialty === filter);

  return (
    <>
      <Seo
        title={`Our Doctors — ${SITE.name}`}
        siteName={SITE.name}
        description={`Meet the doctors at ${SITE.name}, Kasdol. View profiles, consultation days and book appointments on WhatsApp.`}
      />
      <PageHeader
        title="Our Doctors"
        description="Profiles below are sample placeholders — actual doctor details will replace them once confirmed by the hospital."
        crumbs={[{ label: "Doctors" }]}
      />
      <section className="py-16 sm:py-20" data-testid="doctors-list-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-10 flex flex-wrap justify-center gap-2" role="group" aria-label="Filter by specialty">
            {specialties.map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => setFilter(s)}
                aria-pressed={filter === s}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy-600 ${
                  filter === s ? "bg-navy-800 text-white" : "border border-slate-300 bg-white text-slate-600 hover:border-navy-400 hover:text-navy-800"
                }`}
                data-testid={`doctor-filter-${s.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {s}
              </button>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            {shown.map((d) => <DoctorCard key={d.slug} doctor={d} />)}
          </div>
        </div>
      </section>
      <AppointmentCTA />
    </>
  );
}
